import React, { createContext, useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../api/axios';

export const TasksContext = createContext();

export const TasksProvider = ({ children }) => {
  const { data: tasks = [], refetch } = useQuery({
    queryKey: ['tasks'],
    queryFn: async () => {
      const res = await api.get('/quests/get-tasks/');
      return res.data.tasks || [];
    },
    refetchInterval: 1 * 60 * 1000, // 1 minute
    staleTime: 1 * 60 * 1000,       // considered fresh for 1 minutes
    refetchOnWindowFocus: true,
  });

  const contextValue = useMemo(() => ({
    tasks,
    refetch,
  }), [tasks, refetch]);

  return (
    <TasksContext.Provider value={contextValue}>
      {children}
    </TasksContext.Provider>
  );
};

export const useTasks = () => useContext(TasksContext);
